import { render, staticRenderFns } from "./TempletSingleStyle.vue?vue&type=template&id=cf3162dc&scoped=true&"
import script from "./TempletSingleStyle.vue?vue&type=script&lang=js&"
export * from "./TempletSingleStyle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf3162dc",
  null
  
)

export default component.exports